export default __webpack_public_path__ + "3f40c816b01851b490c9a66c904006ce.glb";